import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  getAspireSyncLogsFailed,
  getAspireSyncLogsStart,
  getAspireSyncLogsSuccess,
  getModMedSyncLogsFailed,
  getModMedSyncLogsStart,
  getModMedSyncLogsSuccess,
  getTouchMDSyncLogsFailed,
  getTouchMDSyncLogsStart,
  getTouchMDSyncLogsSuccess,
  getRpaSyncLogsFailed,
  getRpaSyncLogsStart,
  getRpaSyncLogsSuccess,
} from 'redux/actions/sync_logs';


export const getAspireSyncLogsAPI = async ({dispatch, currentPage, rowsPerPage}) => {
  try {
    dispatch(getAspireSyncLogsStart());
    const { data } = await api.get(`${shopManagerApi}/aspire/api/sync-logs?page=${currentPage}&limit=${rowsPerPage}`);
    dispatch(getAspireSyncLogsSuccess(data));
  } catch (e) {
    dispatch(getAspireSyncLogsFailed(e));
  }
};

export const getTouchMDSyncLogsAPI = async ({dispatch, currentPage, rowsPerPage}) => {
  try {
    dispatch(getTouchMDSyncLogsStart());
    const { data } = await api.get(`${shopManagerApi}/touchmd/api/sync-logs?page=${currentPage}&limit=${rowsPerPage}`);
    dispatch(getTouchMDSyncLogsSuccess(data));
  } catch (e) {
    dispatch(getTouchMDSyncLogsFailed(e));
  }
};

export const getModMedSyncLogsAPI = async ({dispatch, currentPage, rowsPerPage}) => {
  try {
    dispatch(getModMedSyncLogsStart());
    const { data } = await api.get(`${shopManagerApi}/modmed/api/sync-logs?page=${currentPage}&limit=${rowsPerPage}`);
    dispatch(getModMedSyncLogsSuccess(data));
  } catch (e) {
    dispatch(getModMedSyncLogsFailed(e));
  }
};

export const getRpaSyncLogsAPI = async ({dispatch, currentPage, rowsPerPage}) => {
  try {
    dispatch(getRpaSyncLogsStart());
    const { data } = await api.get(`${shopManagerApi}/rpa/sync-logs?page=${currentPage}&page_size=${rowsPerPage}`);

    dispatch(getRpaSyncLogsSuccess(data));
  } catch (e) {
    dispatch(getRpaSyncLogsFailed(e));
  }
};
